import { apiClient } from '@/lib/api/client'
import { useToast } from '@chakra-ui/react'
import { useState } from 'react'

type UseSyncStaysPropertiesReturn = {
  syncStaysProperties: () => Promise<void>
  isLoading: boolean
}

export const useSyncStaysProperties = (): UseSyncStaysPropertiesReturn => {
  const toast = useToast()
  const [isLoading, setIsLoading] = useState(false)

  const syncStaysProperties = async () => {
    setIsLoading(true)
    try {
      await apiClient.invoke('sync-stays-properties')
      toast({
        title: 'Successo na sincronização',
        description: 'Propriedades Stays sincronizadas com sucesso.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })
    } catch {
      toast({
        title: 'Falha na sincronização',
        description:
          'Não foi possível sincronizar as propriedades com a stays, a lista de propriedades pode estar desatualizada.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      })
    } finally {
      setIsLoading(false)
    }
  }

  return { syncStaysProperties, isLoading }
}
